module.exports = __webpack_public_path__ + "static/img/tit4.be44093a.png";